import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  scrollToTop(event) {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}
